import { getFirestore } from "../components/Auth/firebase";
import { Low, Medium, High } from "../components/Tasks/Board/Icons";
import { doc, setDoc } from "firebase/firestore";

export const extractPriority = (priority) => {
  switch (priority) {
    case "low":
      return <Low />;
    case "medium":
      return <Medium />;
    case "high":
      return <High />;
    default:
      return null;
  }
};

export const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};

export const createBoardForUser = async (userId) => {
  const db = getFirestore();
  const tasks = [
    {
      id: "1",
      title: "Welcome to Agilix 🙌",
      description:
        "Agilix is a Kanban planner that helps you to focus on what matters most.",
      priority: "low",
      dateAdded: new Date(),
      todos: [],
    },
    // Add other tasks here
  ];

  const columns = [
    { title: "Backlog", taskIds: ["1", "2"] },
    { title: "In Progress", taskIds: ["3", "5", "7"] },
    { title: "Done", taskIds: ["6"] },
    { title: "Waiting", taskIds: ["4"] },
  ];

  const boardRef = doc(db, `users/${userId}/boards/first`);

  await setDoc(boardRef, { name: "Main Board" });

  for (const c of columns) {
    await setDoc(doc(boardRef, "columns", c.title), {
      title: c.title,
      taskIds: c.taskIds,
    });
  }

  for (const t of tasks) {
    await setDoc(doc(boardRef, "tasks", t.id), t);
  }
};
